// 转化漏斗埋点：view（页面打开）/ start（发起操作）/ done（完成）
const API_BASE = () =>
  window.location.hostname === 'localhost' ? 'http://localhost:8090/api' : '/api';

export const track = (entry, event, address) => {
  try {
    fetch(API_BASE() + '/funnel/track', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ entry, event, address: address || '' }),
    });
  } catch (e) { /* 埋点失败不影响主流程 */ }
};
